import { CALL_API } from "../middleware";
import { NomineeType,Bank } from "../types/api-types";
import { GET_CONSENT_OTP, GET_CONSENT_OTP_SUCCESS, GET_CURRENT_CONSENT_APPLICATION, GET_CURRENT_CONSENT_APPLICATION_SUCCESS, GET_VERIFY_CONSENT_OTP_SUCCESS, GET_VERIFY_CONSENT_OTP, GET_RESEND_CONSENT_OTP_SUCCESS, GET_RESEND_CONSENT_OTP, CHECK_CONSENT_COMPLETED_SUCCESS, CHECK_CONSENT_COMPLETED, GET__APPLICATION_LOGIN_DETAILS_SUCCESS, GET__APPLICATION_LOGIN_DETAILS } from "../types/consent";

export type GetCurrentConsentApplicationBody = {
  code?: string;
  isSuccess?: boolean;
  message?: string;
  id?: string;
  applicationNumber?: string;
  modeOfHolding?: string;
  firstApplicantId?: string;
  secondApplicantId?: string;
  thirdApplicantId?: string;
  name?: string;
  mobile: string;
  countryCode: string;
  countryNameAndCode: string;
  email?: string;
  panNo?: string;
  applicant_type?: string;
  isConsentVerified?: boolean;

  noOfApplicants: number
  primaryHolder: string
  primaryHolderPan: string
  secondHolder: string
  secondHolderPan: string
  thirdHolder: string
  thirdHolderPan: string
  nominees: NomineeType[];
  banks:Bank[];
  uuid:string;

};

export type GetConsentOtpBody = {
  countryCode?: string;
  email?: string;
  phone?: string;
  verificationToken?: string;
  code?: string;
  message?: string;
  numberOfOTPTries?: number
  otpRefNo?: string
}

export type GetResendOtpBody = {
  message?: string;
  status?: boolean;
  data:{
    id:string;
    token:string;
  }
}

export type CheckConsentCompletedBody = {
  message?: string;
  result?: {
    applicantsIds?: string[];
  };
}

export const GetCurrentConsentApplication =
  ({ applicantId, referenceId }: { applicantId?: string, referenceId: string }) =>
    async (dispatch: any): Promise<GetCurrentConsentApplicationBody> => {
      return await dispatch({
        [CALL_API]: {
          // url: `/onboarding/applications/get-application-by-referenceId/${referenceId}`,
          // url: `/onboarding/account-consent/get-application-by-referenceId/${applicantId}/${referenceId}`,
          url: `/onboarding/account-consent/get-application-by-referenceId/${referenceId}`,
          method: 'GET',
          types: [GET_CURRENT_CONSENT_APPLICATION_SUCCESS, GET_CURRENT_CONSENT_APPLICATION],
        },
      });
    };

export const GetConsentOtp =
  ({ applicantId, referenceId }: { applicantId: string, referenceId: string }) =>
    async (dispatch: any): Promise<GetConsentOtpBody> => {
      return await dispatch({
        [CALL_API]: {
          // url: `/onboarding/applications/get-consent-otp/${applicationId}`,
          url: `/onboarding/account-consent/get-consent-otp/${applicantId}/${referenceId}`,
          method: 'GET',
          types: [GET_CONSENT_OTP_SUCCESS, GET_CONSENT_OTP],
        },
      });
    };

export const VerifyConsentOtp =
  (body: { applicantId: string, verificationToken: string, otp: string, referenceId: string, otpRefNo: string }) =>
    async (dispatch: any): Promise<GetCurrentConsentApplicationBody> => {
      return await dispatch({
        [CALL_API]: {
          // url: `/onboarding/applications/verify-consent-otp`,
          url: `/onboarding/account-consent/verify-consent-otp`,
          method: 'POST',
          types: [GET_VERIFY_CONSENT_OTP_SUCCESS, GET_VERIFY_CONSENT_OTP],
          body,
        },
      });
    };

export const ResendConsentMail =
  (body: { applicationId: string, applicantId: string }) =>
    async (dispatch: any): Promise<GetResendOtpBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/resend-consent-mail `,
          method: 'POST',
          types: [GET_RESEND_CONSENT_OTP_SUCCESS, GET_RESEND_CONSENT_OTP],
          body,
        },
      });
    };

export const CheckConsentCompleted =
  (applicationId: string) =>
    async (dispatch: any): Promise<CheckConsentCompletedBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/account-consent/check-consent-completed/${applicationId}`,
          types: [CHECK_CONSENT_COMPLETED_SUCCESS, CHECK_CONSENT_COMPLETED],
          method: 'GET',
        },
      });
    };

export const GetApplicationLoginDetails =
  ({ referenceId }: { referenceId: string }) =>
    async (dispatch: any): Promise<GetCurrentConsentApplicationBody> => {
      return await dispatch({
        [CALL_API]: {
          // url: `/onboarding/applications/get-application-by-referenceId/${referenceId}`,
          url: `/onboarding/account-consent/get-application-by-referenceId/${referenceId}`,
          method: 'GET',
          types: [GET__APPLICATION_LOGIN_DETAILS_SUCCESS, GET__APPLICATION_LOGIN_DETAILS],
        },
      });
    };